import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';

@Component({
  selector: 'app-list-category',
  templateUrl: './list-category.component.html',
  styleUrls: ['./list-category.component.scss']
})
export class ListCategoryComponent implements OnInit {

  categories:any;
  id;
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router:Router,
    ) {
      
     }

  ngOnInit() {
    this.getAllCategories();
  }

  getAllCategories() {
    this.apiService.get(this.apiConfig.getAllCategiry)
      .subscribe((res: any) => {
        this.categories = res.data.ecommerce_categories
        console.log(this.categories);
      }, err => {
        console.log(err);
      })
  }

    editCategory(category){
      this.router.navigateByUrl('/hubAdmin/edit-category/' + category.id);
    }

}
